import styled from "styled-components";
import React from "react";

const About = () => {
    return (
        <Contents>
            <div id="journey" className="top-space"></div>
            <div className="cover">
                
                <h1>
                    Our Journey
                </h1>
                <p>
                We have 4 years of experience and also glad to inform that over 400+ projects were completed! Our customers are happy with our products built with love &nbsp;<span>&#x2764;&#xfe0f;</span>.
                </p>
                <a href='/gallery'>
                    <button>
                        <h3>View Gallery</h3>
                    </button>
                </a>
            </div>
        </Contents>
    )
}

const Contents = styled.div`
    color: #fff;
    @media screen and (max-width: 600px) {
        background: #000 url('/images/fixedbg-min.jpg') no-repeat scroll center;
        background-size: cover;
    }
    @media screen and (min-width: 600px) {
        :before {
            content: '';
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            left: 0;
            background: #000 url('/images/fixedbg-min.jpg') no-repeat center;
            background-size: cover;
            will-change: transform;
            z-index: -1;
        }
        .cover {
            min-height: 120vh;
        }
    }
    .cover {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: center
        ;
        text-align: center;
        margin: 0 auto;
        background: rgba(0,0,0,0.7);
    }
    h1 {
        font-weight: 900;
        width: 80%;
        color: rgba(255,255,255,0.6);
        margin-top: 2rem;
    }
    p {
        font-weight: 700;
        width: 80%;
        font-size: 1.4rem;
        color: rgba(255,255,255,0.6);
        margin: 2rem auto;

    }
    button {
        color: #fff;
        background: transparent;
        margin-bottom: 4rem;
        padding: 1rem;
        font-size: 1rem;
        border: 2px solid white;
    }
    button:focus,button:hover,button:active {
        color: rgba(0,0,0,0.6);
    }
    a {
        text-decoration: none;
    }
    button:hover {
        background: #fff;
    }
    h3 {
        cursor: pointer
    }
    `;

export default React.memo(About);
